import ga from "@store/Framework/Common/GoogleAnalytics";
import { TrackEventBaseParameters } from "@store/Framework/Common/GoogleAnalytics/trackers/trackEvent";

/* ---------------------------------------------------------------------------------------------------- */
// Custom Event
/* ---------------------------------------------------------------------------------------------------- */

export interface TrackPrintParameters extends TrackEventBaseParameters {}

const trackPrint = (parameters: TrackPrintParameters, options?: Toolkit.GoogleAnalytics.Options) => {
    return ga.track.event({ action: "print", ...parameters }, options);
};

export default trackPrint;
